/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for general settings by institute
 * @export
 * @interface PlanningGeneralSettingsResponse
 */
export interface PlanningGeneralSettingsResponse {
    /**
     * base unit to define appointments duration (all appointments durations will be a multiple of this value)
     * @type {number}
     * @memberof PlanningGeneralSettingsResponse
     */
    baseAppointmentDurationInMinutes?: number;
    /**
     * list of date with special day configuration
     * @type {Array<string>}
     * @memberof PlanningGeneralSettingsResponse
     */
    dateWithSpecialDay?: Array<string>;
}

/**
 * Check if a given object implements the PlanningGeneralSettingsResponse interface.
 */
export function instanceOfPlanningGeneralSettingsResponse(value: object): value is PlanningGeneralSettingsResponse {
    return true;
}

export function PlanningGeneralSettingsResponseFromJSON(json: any): PlanningGeneralSettingsResponse {
    return PlanningGeneralSettingsResponseFromJSONTyped(json, false);
}

export function PlanningGeneralSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanningGeneralSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseAppointmentDurationInMinutes': json['baseAppointmentDurationInMinutes'] == null ? undefined : json['baseAppointmentDurationInMinutes'],
        'dateWithSpecialDay': json['dateWithSpecialDay'] == null ? undefined : json['dateWithSpecialDay'],
    };
}

export function PlanningGeneralSettingsResponseToJSON(json: any): PlanningGeneralSettingsResponse {
    return PlanningGeneralSettingsResponseToJSONTyped(json, false);
}

export function PlanningGeneralSettingsResponseToJSONTyped(value?: PlanningGeneralSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseAppointmentDurationInMinutes': value['baseAppointmentDurationInMinutes'],
        'dateWithSpecialDay': value['dateWithSpecialDay'],
    };
}

